import React from 'react';
import { formatCharacter, formatPageNumber } from '@monorepo/shared/src/util/telemetry-util';
import usePage from '@monorepo/shared/src/hooks/use-page';
import useReadAloudStore from '@monorepo/shared/src/graph/state/query-hooks/use-read-aloud-store';
import useTelemetry from '@monorepo/shared/src/hooks/use-telemetry';
import ReadAloudFooter from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/ReadAloud/components/ReadAloudFooter';
import { BaseHtmlRenderingProviders } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@legacy/HTMLRenderEngine';
import { ReadAloud } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/ReadAloud';
import {
  ApplicationSection,
  BookType,
  PageLayout,
} from '@monorepo/shared/src/graph/schema-generated-types-educator';
import { ActivityTypes, TelemetryEvents } from '@monorepo/shared/src/types';
import { AppRoutes } from 'types';

type Props = {
  letter?: string;
};

const ReadAloudModal: React.FC<Props> = ({ letter }) => {
  const [{ noOfPages }] = usePage();
  const [, { fireEvent: fireAccessActivityPageEvent }] = useTelemetry(
    TelemetryEvents.ACCESS_ACTIVITY_PAGE
  );
  const [, { fireEvent: fireReadBookEvent }] = useTelemetry(TelemetryEvents.READ_BOOK);

  const singlePage = noOfPages === 1;

  const [{ book, pages, loading, error }] = useReadAloudStore({
    bookType: location.pathname.includes(AppRoutes.CLASSROOM_BOOKS)
      ? BookType.CLASSROOM_BOOK
      : BookType.LETTER_BOOK,
    letter,
  });

  const createTelemetryEventFn = (type: string, data: any) => {
    const isLetterBooks = window.location.pathname.includes('letter-books');
    const isAccessActivityPage = type === 'accessActivityPage';
    const readBookTelemData = {
      ...data,
      activityType:
        data?.activityType === 'readStory' ? ActivityTypes.READ_STORY : ActivityTypes.READ_ALOUD,
      pageNumber: formatPageNumber(data?.pageNumber),
      pageLayout: singlePage ? PageLayout.SINGLE_PAGE : PageLayout.DOUBLE_PAGE,
      section: isLetterBooks ? ApplicationSection.LETTER_BOOKS : ApplicationSection.LETTER_LEARNING,
      character: data?.character ? formatCharacter(data.character) : undefined,
    };
    if (isAccessActivityPage) {
      delete readBookTelemData.bookType;
    }
    if (!data?.pageId) return;

    if (isAccessActivityPage) {
      fireAccessActivityPageEvent(readBookTelemData);
      return;
    }

    fireReadBookEvent(readBookTelemData);
  };

  const bookData = {
    book,
    pages,
    loading,
    error,
    createTelemetryEventFn: createTelemetryEventFn,
  };

  return (
    <BaseHtmlRenderingProviders noOfPages={noOfPages} WordFeature={null}>
      <div
        style={{
          backgroundColor: '#fff',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          height: '100%',
          width: '100%',
        }}
      >
        <div style={{ flex: 1, padding: `1rem 0px` }}>
          <ReadAloud singlePage={singlePage} bookData={bookData} isOpen />
        </div>
        <ReadAloudFooter book={bookData?.book} pages={bookData?.pages} />
      </div>
    </BaseHtmlRenderingProviders>
  );
};

export default ReadAloudModal;
